<template>
    <div>
        <PayAlert :isShow="isShow" @increase="getAlertState"/>
        <ContentHeader :disabled="false" :title="lang('singleLeftMenuText1_4',language)" :tip_text_arr="headerTipArr"/>
        <Card>
            <Spin size="large" fix v-if="stuJobListLoading"></Spin>
            <p slot="title" :style="{textAlign:'left',fontSize:'18px',fontWeight:'bold'}">
                {{lang('singleJobTitle',language)}}
            </p>
            <Row>
                <Col span="6" :style="{borderRight: '1px solid #E8E9F2'}">
                    <p :style="{color: '#4F6B87'}">{{lang('singleStuJobTipTitle1',language)}}</p>
                    <p :style="{fontFamily:'ArialMT',color: '#595959',fontSize:'36px'}">
                        {{completedJobsCnt}}
                        <span :style="{fontSize:'18px'}">{{lang('singleJobText1',language)}}</span>
                    </p>
                </Col>
                <Col span="6" :style="{borderRight: '1px solid #E8E9F2'}">
                    <p :style="{color: '#4F6B87'}">{{lang('singleStuJobTipTitle2',language)}}</p>
                    <p :style="{fontFamily:'ArialMT',color: '#595959',fontSize:'36px'}">
                        {{completedJobsRate*100 | numFilter}}%
                    </p>
                </Col>
                <Col span="6" :style="{borderRight: '1px solid #E8E9F2'}">
                    <p :style="{color: '#4F6B87'}">{{lang('singleStuJobTipTitle3',language)}}</p>
                    <p :style="{fontFamily:'ArialMT',color: '#595959',fontSize:'16px',fontWeight:'bold'}" v-if="completedJobsTypeRatio !== null">
                        {{lang('singleJobText2',language)}}
                        {{completedJobsTypeRatio.readOnlyRatio * 100 | numFilter}}%，
                        {{lang('singleJobText4',language)}}
                        {{completedJobsTypeRatio.retellOnlyRatio * 100 | numFilter}}%,
                        {{lang('singleJobText6',language)}}
                        {{completedJobsTypeRatio.bothRatio * 100 | numFilter}}%
                    </p>
                </Col>
                <Col span="6">
                    <p :style="{color: '#4F6B87'}">{{lang('singleStuJobTipTitle4',language)}}</p>
                    <p :style="{fontFamily:'ArialMT',color: '#595959',fontSize:'36px'}">
                        {{wawaCoins}}
                        <span :style="{fontSize:'18px'}">{{lang('singleJobText3',language)}}</span>
                    </p>
                </Col>
            </Row>
        </Card>
        <br/>

        <Row>
            <Col span="24">
                <SelectDate @increase="getDateRange"/>
                <Card>
                    <p slot="title" :style="{textAlign:'left',fontSize:'18px',fontWeight:'bold'}">
                        {{lang('singleJobText5',language)}}
                    </p>
                    <Button slot="extra" type="primary" @click="exportData">
                        <Icon type="ios-download-outline"></Icon>
                        {{lang('exportText',language)}}
                    </Button>
                    <Row>
                        <div v-for="(item,index) in jobList" :key="index">
                            <Card>
                                <p slot="title" :style="{textAlign:'left',fontSize:'16px'}">
                                    {{formatDate(item.effective_time)}}&nbsp;&nbsp;丨&nbsp;&nbsp;
                                    <span v-if="item.readBooksNum>0"><Icon type="ios-eye"></Icon>&nbsp;&nbsp;{{lang('singleJobText7',language).replace('@',item.readBooksNum)}}&nbsp;&nbsp;</span>
                                    <span v-if="item.retellBooksNum>0"><Icon type="ios-mic"></Icon>&nbsp;&nbsp;{{lang('singleJobText9',language).replace('@',item.retellBooksNum)}}</span>
                                </p>
                                <div slot="extra">
                                    <span v-if="currentTimeTamp>item.ineffective_time" style="font-weight: bold">{{lang('singleJobText15',language)}}</span>
                                    <span v-else style="font-weight: bold">{{item.completed?lang('singleJobText11',language):lang('singleJobText13',language)}}</span>
                                </div>
                                <Row>
                                    <div v-for="book in item.books" :key="book" class="bookWrapper">
                                        <img :src="book.book.coverUri" class="bookCover"/>
                                    </div>
                                </Row>
                            </Card>
                            <br>
                        </div>

                    </Row>
                    <br>
                    <Page :total="total" show-sizer show-total show-elevator @on-change="changePage"
                          :page-size-opts="[10, 20, 30, 40, 50]" :page-size="pageSize"
                          @on-page-size-change="changePageSize" placement="top" width="" v-if="jobList !== null && jobList.length>0"/>

                </Card>
            </Col>
        </Row>

    </div>
</template>

<script>
    var _hmt = _hmt || [];
    (function() {
        var hm = document.createElement("script");
        hm.src = "https://hm.baidu.com/hm.js?4537bce4a2128c98b476fa3bc3b18f86";
        var s = document.getElementsByTagName("script")[0];
        s.parentNode.insertBefore(hm, s);
    })();

    import {lang} from "@/utils/language.js";
    import store from '@/store/index.js';
    import {formatDate} from '@/utils/common.js';
    import config from '@/utils/config.js';
    import ContentHeader from '@/components/ContentHeader.vue';
    import {getSingleData,getSingleArgs} from '@/utils/net.js';
    import SelectDate from '@/components/SelectDate.vue';
    import PayAlert from '@/components/PayAlert.vue';

    export default {
        name: 'TeacherJob',
        store,
        components: {
            ContentHeader,
            SelectDate,
            PayAlert
        },
        data() {
            return {
                isShow:false,
                formatDate: formatDate,
                imgUrl: {
                    finish: require('@/assets/finish.png'),
                },
                lang: lang,
                stateLang: '',
                headerTipArr: [],
                stuJobListLoading: false,
                userId: '',
                completedJobsCnt: '',
                completedJobsRate: '',
                completedJobsTypeRatio:{},
                wawaCoins: '',
                start: '',
                end: '',
                total: 0,
                page: 1,
                pageSize: 10,
                jobList: [],
                currentTimeTamp : Date.parse(new Date())
            }
        },
        mounted() {
            this.loadHeaderTipArr();

        },
        methods: {
            loadHeaderTipArr() {
                this.headerTipArr.splice(0);
                for (var i = 1; i <= 4; i++) {
                    var item = {};
                    item.title = this.lang('singleStuJobTipTitle' + i, this.language);
                    item.content = this.lang('singleStuJobTipContent' + i, this.language);
                    if (JSON.stringify(item) !== '') {
                        this.headerTipArr.push(item);
                    }
                }
            },
            getStuJobList() {
                let that = this;
                that.stuJobListLoading = true;
                getSingleData({
                    context: that,
                    url: '/open/reading/rjob/list/stu',
                    params: {
                        start: that.start,
                        end: that.end,
                        page: that.page,
                        pageSize: that.pageSize,
                        de: config.de
                    },
                    onCallBack: function (retMap) {
                        that.total = retMap.total;
                        that.completedJobsCnt = retMap.primary.completedJobsCnt;
                        that.completedJobsRate = retMap.primary.completedJobsRate;
                        that.completedJobsTypeRatio = retMap.primary.completedJobsTypeRatio;
                        that.wawaCoins = retMap.primary.wawaCoins;
                        that.jobList = retMap.list;
                        that.stuJobListLoading = false;
                    },
                    onErr(res) {
                        that.$Message.error(that.lang('systemError', that.language));
                        that.stuJobListLoading = false;
                    }
                })
            },

            getDateRange(data) {
                this.start = data.t2;
                this.end = data.t1;
                this.getStuJobList();
            },
            changePage(page) {
                this.page = page;
                this.getStuJobList();
            },
            changePageSize(pageSize) {
                this.pageSize = pageSize;
                this.getStuJobList();
            },

            getAlertState(data){
                this.isShow = data
            },

            exportData(){
                if(this.userInfo.isSvip){
                    let that = this;
                    let path = getSingleArgs({
                        context: that,
                        url: '/open/reading/rjob/list/stu/export',
                        params: {
                            start: that.start,
                            end: that.end,
                            de: config.de,
                        }
                    })
                    let a = document.createElement("a");
                    a.setAttribute("href", path);
                    a.setAttribute("target", "_blank");
                    a.click();
                }else{
                    this.isShow = true;
                }
            }
        },
        computed: {
            language: function () {
                this.stateLang = store.state.lang;
                return store.state.lang;
            },
            userInfo: function () {
                return store.getters.getUser;
            }
        },
        watch: {
            stateLang: function () {

            }
        },
        filters: {
            numFilter(value) {
                // 截取当前数据到小数点后两位
                let realVal = parseFloat(value).toFixed(2);
                // num.toFixed(2)获取的是字符串
                return parseFloat(realVal);
            }
        }

    }
</script>

<style scoped>
    .bookWrapper {
        float: left;
        width: 120px;
        height: 140px;
        text-align: center;
    }

    .bookCover {
        width: 100px;
        height: 137.5px;
        border-radius: 5px;
    }

</style>
